import {BaseModel} from "./BaseModel";

export class UserModel extends BaseModel {
    constructor(cookie = "") {
        super();
        this.cookie = cookie;

    }

    RouteName = "User";
    AuthState = true;

    async Login(model) {
        try {
            return await this.baseApi
                .axiosInstance(this.cookie)
                .post(`${this.RouteName}/Login`, model);
        } catch (e) {
            const error = e;
            throw error.response?.data;
        }
    }

    async Register(model) {
        try {
            return await this.baseApi
                .axiosInstance(this.cookie)
                .post(`${this.RouteName}/register`, model);
        } catch (e) {
            const error = e;
            throw error.response?.data;
        }
    }

    async UpdateInformation(model) {
        try {
            return await this.baseApi
                .axiosInstance(true, this.cookie)
                .post(`${this.RouteName}/UpdateInformation`, model);
        } catch (e) {
            const error = e;
            throw error.response?.data;
        }
    }

    async Information() {
        try {
            return await this.baseApi
                .axiosInstance(true, this.cookie)
                .get(`${this.RouteName}/Information`);
        } catch (e) {
            const error = e;
            throw error.response?.data;
        }
    }

    getStudentsPaginate(pageNumber, pageSize = 10) {
        try {
            return this.baseApi
                .axiosInstance(this.AuthState, this.cookie)
                .post(
                    `${this.RouteName}/GetAllStudents?pageNumber=${pageNumber}&pageSize=${pageSize}`
                );
        } catch (e) {
            const error = e;
            throw error.response?.data.message;
        }
    }

    getUsersPaginate(pageNumber, pageSize = 10) {
        try {
            return this.baseApi
                .axiosInstance(this.AuthState, this.cookie)
                .post(
                    `${this.RouteName}/GetAllUsers?pageNumber=${pageNumber}&pageSize=${pageSize}`
                );
        } catch (e) {
            const error = e;
            throw error.response?.data.message;
        }
    }

    GetStudentSalamatInfo(id,userid) {
        try {
            return this.baseApi
                .axiosInstance(this.AuthState, this.cookie)
                .post(
                    `${this.RouteName}/GetStudentSalamatInfo?id=${id}&userid=${userid}`)
                ;
        } catch (e) {
            const error = e;
            throw error.response?.data.message;
        }
    }

    GetStudentInfo(id) {
        try {
            return this.baseApi
                .axiosInstance(this.AuthState, this.cookie)
                .post(
                    `${this.RouteName}/GetStudentInfo?id=${id}`)
                ;
        } catch (e) {
            const error = e;
            throw error.response?.data.message;
        }
    }
    GetStudentSalamatInfoHistory(id) {
        try {
            return this.baseApi
                .axiosInstance(this.AuthState, this.cookie)
                .get(
                    `${this.RouteName}/GetStudentSalamatInfoHistory?userid=${id}`)
                ;
        } catch (e) {
            const error = e;
            throw error.response?.data.message;
        }
    }
    GetStudentLifeStyleHistory(id) {
        try {
            return this.baseApi
                .axiosInstance(this.AuthState, this.cookie)
                .get(
                    `${this.RouteName}/GetStudentLifeStyleHistory?userid=${id}`)
                ;
        } catch (e) {
            const error = e;
            throw error.response?.data.message;
        }
    }

    GetStudentLifeStyle(id,userid) {
        try {
            return this.baseApi
                .axiosInstance(this.AuthState, this.cookie)
                .post(
                    `${this.RouteName}/GetStudentLifeStyle?id=${id}&userid=${userid}`)
                ;
        } catch (e) {
            const error = e;
            throw error.response?.data.message;
        }
    }

    async GiveStudentMedals(model) {
        try {
            return await this.baseApi
                .axiosInstance(true, this.cookie)
                .post(`${this.RouteName}/GiveStudentMedals`, model);
        } catch (e) {
            const error = e;
            throw error.response?.data;
        }
    }

    async GiveNoskhe(model) {
        try {
            return await this.baseApi
                .axiosInstance(true, this.cookie)
                .post(`${this.RouteName}/GiveNoskhe`, model);
        } catch (e) {
            const error = e;
            throw error.response?.data;
        }
    }

    async GetMedal(id) {
        try {
            return await this.baseApi
                .axiosInstance(true, this.cookie)
                .get(`${this.RouteName}/GetMedal?userId=${id}`);
        } catch (e) {
            const error = e;
            throw error.response?.data;
        }
    }

    async ChangeUserStatus(id) {
        try {
            return await this.baseApi
                .axiosInstance(true, this.cookie)
                .post(`${this.RouteName}/ChangeUserStatus?id=${id}`);
        } catch (e) {
            const error = e;
            throw error.response?.data;
        }
    }

    async ChangeUserBmi(id) {
        try {
            return await this.baseApi
                .axiosInstance(true, this.cookie)
                .post(`${this.RouteName}/ChangeUserBmi?id=${id}`);
        } catch (e) {
            const error = e;
            throw error.response?.data;
        }
    }

    async ChangePassword(id, password) {
        try {
            return await this.baseApi
                .axiosInstance(true, this.cookie)
                .post(`${this.RouteName}/ChangePassword?id=${id}&password=${password}`);
        } catch (e) {
            const error = e;
            throw error.response?.data;
        }
    }

    async GetSearch(Name = "",
                    CodeMeli = "",
                    AzSabt = "",
                    TaSabt = "",
    ) {
        try {

            return await this.baseApi
                .axiosInstance(true, this.cookie)
                .get(`${this.RouteName}/search?Name=${Name}&CodeMeli=${CodeMeli}&AzSabt=${AzSabt}&TaSabt=${TaSabt}`)
        } catch (e) {
            const error = e;
            throw error.response?.data;
        }
    }

    async GetUserSearch(Username = "",
                        Name = "",
                        Vaziat = "",
                        Role = "",
                        AzSabt = "",
                        TaSabt = "",
    ) {
        try {

            return await this.baseApi
                .axiosInstance(true, this.cookie)
                .get(`${this.RouteName}/GetUserSearch?Username=${Username}&Name=${Name}&Vaziat=${Vaziat}&Role=${Role}&AzSabt=${AzSabt}&TaSabt=${TaSabt}`)
        } catch (e) {
            const error = e;
            throw error.response?.data;
        }
    }

    async AddSaheb(id) {
        try {
            return await this.baseApi
                .axiosInstance(true, this.cookie)
                .post(`${this.RouteName}/AddSaheb?CodeMeli=${id}`);
        } catch (e) {
            const error = e;
            throw error.response?.data;
        }
    }

    // async AddSaheb(sahebcodeMeli) {
    //     try {
    //         return await this.baseApi
    //             .axiosInstance(true, this.cookie)
    //             .post(`${this.RouteName}/AddSaheb?CodeMeli=${sahebcodeMeli}`, model);
    //     } catch (e) {
    //         const error = e;
    //         throw error.response?.data;
    //     }
    // }
}

